// import { yupResolver } from '@hookform/resolvers/yup';
// import {
//   Alert,
//   Autocomplete,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import {
//   FaCalendarAlt,
//   FaCamera,
//   FaClock,
//   FaExclamationTriangle,
//   FaFileAlt,
//   FaSignature,
//   FaUndo,
//   FaUser
// } from 'react-icons/fa';
// import { FiArrowLeft, FiTrash } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ClientIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
// import {
//   clearClientIncidentState,
//   ClientIncidentFormData,
//   submitClientIncident
// } from 'slices/NdisSlices/reportAllForms/clientIncidentSlice';
// import { fetchParticipantsList } from 'slices/HomeTilesSlices';
// import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
// import * as yup from 'yup';

// // Interfaces
// interface Client {
//   label: string;
//   id: number;
//   email: string;
// }

// interface StaffMember {
//   name: string;
//   email: string;
// }

// interface Manager {
//   name: string;
//   email: string;
// }

// interface UserDetails {
//   email: string;
//   name: string;
//   role: { role_id: string }[];
// }

// // Validation schemas
// const mainSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_incident: yup.string().required('Date of incident is required'),
//     time_of_incident: yup.string().required('Time of incident is required'),
//     location_of_incident: yup.string().required('Location of incident is required'),
//     description: yup.string().required('Description of incident is required'),
//     individuals_involved: yup.string().required('Name(s) of individuals involved is required'),
//     witnesses: yup.string().optional().default(''),
//     actions_taken_during: yup.string().required('Actions taken during incident is required'),
//     client_name: yup.string().required('Client name is required'),
//     ndis_number: yup.string().required('NDIS number is required'),
//     client_condition: yup.string().required('Client condition is required'),
//     was_injured: yup.string().required('Please specify if anyone was injured'),
//     injury_description: yup.string().when('was_injured', {
//       is: 'Yes',
//       then: (schema) => schema.required('Nature and extent of injuries is required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     first_aid_provided: yup.string().when('was_injured', {
//       is: 'Yes',
//       then: (schema) => schema.required('Please specify if first aid was provided'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     property_damage: yup.string().required('Please specify if there was property damage'),
//     damage_description: yup.string().when('property_damage', {
//       is: 'Yes',
//       then: (schema) => schema.required('Property damage details are required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     immediate_actions: yup.string().required('Immediate actions taken is required'),
//     escalated_to_management: yup.string().optional().default(''),
//     manager_name: yup.string().optional().default(''),
//     reported_externally: yup.string().optional().default(''),
//     external_party: yup.string().optional().default(''),
//     follow_up: yup.string().optional().default(''),
//     recommendations: yup.string().optional().default(''),
//     support_worker_name: yup.string().required('Support worker name is required'),
//     support_worker_signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required'),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// const followUpSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_incident: yup.string().optional().default(''),
//     time_of_incident: yup.string().optional().default(''),
//     location_of_incident: yup.string().optional().default(''),
//     description: yup.string().optional().default(''),
//     individuals_involved: yup.string().optional().default(''),
//     witnesses: yup.string().optional().default(''),
//     actions_taken_during: yup.string().optional().default(''),
//     client_name: yup.string().optional().default(''),
//     ndis_number: yup.string().optional().default(''),
//     client_condition: yup.string().optional().default(''),
//     was_injured: yup.string().optional().default(''),
//     injury_description: yup.string().optional().default(''),
//     first_aid_provided: yup.string().optional().default(''),
//     property_damage: yup.string().optional().default(''),
//     damage_description: yup.string().optional().default(''),
//     immediate_actions: yup.string().optional().default(''),
//     escalated_to_management: yup.string().required('Please specify if incident was escalated'),
//     manager_name: yup.string().when('escalated_to_management', {
//       is: 'Yes',
//       then: (schema) => schema.required('Manager name is required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     reported_externally: yup
//       .string()
//       .required('Please specify if incident was reported externally'),
//     external_party: yup.string().when('reported_externally', {
//       is: 'Yes',
//       then: (schema) => schema.required('External report details are required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     follow_up: yup.string().required('Follow-up actions are required'),
//     recommendations: yup.string().required('Recommendations are required'),
//     support_worker_name: yup.string().optional().default(''),
//     support_worker_signature: yup.string().optional().default(''),
//     date_completed: yup.string().optional().default(''),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// interface Props {
//   initialData?: ClientIncident;
//   onClose?: () => void;
// }

// const ClientIncidentForm: React.FC<Props> = ({ initialData, onClose }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.clientIncident);
//   const [photoPreview, setPhotoPreview] = useState<string | null>(null);
//   const inputRef = useRef<HTMLInputElement>(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Redux state data
//   const selectedProjectId = useTypedSelector(
//     (state: RootState) => state.homeTilesServices.selectedProjectId
//   );
//   const selectedServiceTitle = useTypedSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle
//   );
//   const participantsList = useTypedSelector(
//     (state: RootState) => state?.homeTilesServices?.participants
//   ) || { participants_list: [] };
//   const supportWorkers = useTypedSelector((state: RootState) =>
//     (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
//       name: worker.name,
//       email: worker.email || ''
//     }))
//   ) as StaffMember[];
//   const managersList = useTypedSelector((state: RootState) =>
//     (state.calendarEvents.staffList?.['Manager'] || []).map((worker: any) => ({
//       name: worker.name,
//       email: worker.email || ''
//     }))
//   ) as Manager[];
//   const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);

//   // Local storage data
//   const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//     label?: string;
//     id?: number;
//     email?: string;
//     ndisNumber?: string;
//   };
//   const loginInfo = localStorage.getItem('user-details');
//   const userDetails: UserDetails | null = loginInfo ? JSON.parse(loginInfo) : null;

//   // Prepare clients list, ensuring selectedClient is included
//   const clientsList = useMemo(() => {
//     const list =
//       participantsList.participants_list?.map(
//         (participant: { name: string; email: string }, index: number) => ({
//           label: participant.name || `Client ${index + 1}`,
//           id: index + 1,
//           email: participant.email
//         })
//       ) || [];
//     if (
//       selectedClient?.label &&
//       selectedClient?.email &&
//       !list.some((client) => client.label === selectedClient.label)
//     ) {
//       list.push({
//         label: selectedClient.label,
//         id: selectedClient.id || list.length + 1,
//         email: selectedClient.email
//       });
//     }
//     return list;
//   }, [participantsList.participants_list, selectedClient]);

//   // State for loading and errors
//   const [isClientsLoading, setIsClientsLoading] = useState(false);
//   const [clientsError, setClientsError] = useState<string | null>(null);
//   const [staffError, setStaffError] = useState<string | null>(null);

//   // Fetch participants
//   useEffect(() => {
//     if (
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       setIsClientsLoading(true);
//       dispatch(
//         fetchParticipantsList({
//           group_id: selectedProjectId || '',
//           service_name_id: selectedServiceTitle || '',
//           nested_component_id: location.pathname,
//           email: userDetails.email,
//           roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//           client_name: ''
//         })
//       )
//         .then(() => {
//           setIsClientsLoading(false);
//         })
//         .catch((error: unknown) => {
//           setIsClientsLoading(false);
//           setClientsError('Failed to load clients. Please try again later.');
//         });
//     } else {
//       setIsClientsLoading(false);
//     }
//   }, [selectedProjectId]);

//   // Fetch staff (support workers and managers)
//   useEffect(() => {
//     if (
//       selectedClient?.label &&
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
//       const basePayload = {
//         group_id: selectedProjectId,
//         service_name_id: selectedServiceTitle.replace(' ', '_'),
//         nested_component_id: 'Staff_List',
//         email_loggedIn_userEmail: userDetails.email,
//         roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//         client_name: selectedClient.label?.replace(' ', '_') || '',
//         approved_user: approvedUser,
//         curr_loggIn_userRoles: userDetails?.name || ''
//       };

//       // Fetch support workers
//       dispatch(fetchStaffByRoles({ ...basePayload, roles: ['Support worker'] }))
//         .then(() => {
//           // Handle success if needed
//         })
//         .catch((error: unknown) => {
//           setStaffError('Failed to load support workers. Please try again later.');
//         });

//       // Fetch managers
//       dispatch(fetchStaffByRoles({ ...basePayload, roles: ['Manager'] }))
//         .then(() => {
//           // Handle success if needed
//         })
//         .catch((error: unknown) => {
//           setStaffError('Failed to load managers. Please try again later.');
//         });
//     }
//   }, [selectedClient?.label]);

//   // Determine which form section to show
//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'incidents';
//   const incidentId = initialData?.id || undefined;

//   const isMainFormRoute = location.pathname === '/Client-Incident';
//   const isFollowUpRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

//   // Check if Follow-Up form is already filled
//   const [alreadyFilled, setAlreadyFilled] = useState(false);
//   useEffect(() => {
//     if (isFollowUpRoute && initialData) {
//       const isFilled = [
//         initialData.follow_up,
//         initialData.recommendations,
//         initialData.escalated,
//         initialData.manager_name,
//         initialData.externally_reported,
//         initialData.external_party
//       ].some((field) => field !== undefined && field !== null && field !== '');
//       setAlreadyFilled(isFilled);
//     } else {
//       setAlreadyFilled(false);
//     }
//   }, [initialData, isFollowUpRoute]);

//   // Find default values for Autocomplete
//   const defaultClient =
//     clientsList.find(
//       (client) => client.label === (initialData?.client_name || selectedClient?.label)
//     ) || null;
//   const defaultSupportWorker =
//     supportWorkers.find((worker) => worker.name === (initialData?.sw_name || userDetails?.name)) ||
//     null;
//   const defaultManager =
//     managersList.find((manager) => manager.name === initialData?.manager_name) || null;

//   // Use separate useForm hooks for each route
//   const defaultDateTime = new Date().toISOString().split('T')[0];
//   const mainForm = useForm<ClientIncidentFormData>({
//     resolver: yupResolver(mainSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_incident: initialData?.date || defaultDateTime,
//       time_of_incident: initialData?.time || '',
//       location_of_incident: initialData?.location || '',
//       description: initialData?.description || '',
//       individuals_involved: initialData?.individuals || '',
//       witnesses: initialData?.witnesses || '',
//       actions_taken_during: initialData?.actions_during || '',
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       ndis_number: initialData?.ndis_number || selectedClient?.ndisNumber || '',
//       client_condition: initialData?.client_condition || '',
//       was_injured: initialData?.injured || '',
//       injury_description: initialData?.injury_details || '',
//       first_aid_provided: initialData?.first_aid || '',
//       property_damage: initialData?.property_damage || '',
//       damage_description: initialData?.damage_description || '',
//       immediate_actions: initialData?.actions_after || '',
//       escalated_to_management: initialData?.escalated || '',
//       manager_name: initialData?.manager_name || '',
//       reported_externally: initialData?.externally_reported || '',
//       external_party: initialData?.external_party || '',
//       follow_up: initialData?.follow_up || '',
//       recommendations: initialData?.recommendations || '',
//       support_worker_name: initialData?.sw_name || userDetails?.name || '',
//       support_worker_signature: initialData?.sw_signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       photo: undefined,
//       client_email: selectedClient?.email || ''
//     }
//   });

//   const followUpForm = useForm<ClientIncidentFormData>({
//     resolver: yupResolver(followUpSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_incident: initialData?.date || '',
//       time_of_incident: initialData?.time || '',
//       location_of_incident: initialData?.location || '',
//       description: initialData?.description || '',
//       individuals_involved: initialData?.individuals || '',
//       witnesses: initialData?.witnesses || '',
//       actions_taken_during: initialData?.actions_during || '',
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       ndis_number: initialData?.ndis_number || '',
//       client_condition: initialData?.client_condition || '',
//       was_injured: initialData?.injured || '',
//       injury_description: initialData?.injury_details || '',
//       first_aid_provided: initialData?.first_aid || '',
//       property_damage: initialData?.property_damage || '',
//       damage_description: initialData?.damage_description || '',
//       immediate_actions: initialData?.actions_after || '',
//       escalated_to_management: initialData?.escalated || '',
//       manager_name: initialData?.manager_name || '',
//       reported_externally: initialData?.externally_reported || '',
//       external_party: initialData?.external_party || '',
//       follow_up: initialData?.follow_up || '',
//       recommendations: initialData?.recommendations || '',
//       support_worker_name: initialData?.sw_name || '',
//       support_worker_signature: initialData?.sw_signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       photo: undefined,
//       client_email: selectedClient?.email || ''
//     }
//   });

//   // Update client_email when client_name changes
//   useEffect(() => {
//     const selectedClientFromList = clientsList.find(
//       (client) => client.label === mainForm.getValues('client_name')
//     );
//     if (selectedClientFromList) {
//       mainForm.setValue('client_email', selectedClientFromList.email);
//     }
//   }, [mainForm.watch('client_name'), clientsList, mainForm]);

//   useEffect(() => {
//     const selectedClientFromList = clientsList.find(
//       (client) => client.label === followUpForm.getValues('client_name')
//     );
//     if (selectedClientFromList) {
//       followUpForm.setValue('client_email', selectedClientFromList.email);
//     }
//   }, [followUpForm.watch('client_name'), clientsList, followUpForm]);

//   const was_injured = isMainFormRoute
//     ? mainForm.watch('was_injured')
//     : followUpForm.watch('was_injured');
//   const property_damage = isMainFormRoute
//     ? mainForm.watch('property_damage')
//     : followUpForm.watch('property_damage');
//   const escalated_to_management = isMainFormRoute
//     ? mainForm.watch('escalated_to_management')
//     : followUpForm.watch('escalated_to_management');
//   const reported_externally = isMainFormRoute
//     ? mainForm.watch('reported_externally')
//     : followUpForm.watch('reported_externally');

//   const handlePhotoChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     onChange: (value: File | undefined) => void
//   ) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       onChange(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPhotoPreview(reader.result as string);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPhotoPreview(null);
//       onChange(undefined);
//     }
//   };

//   const handleRemovePhoto = () => {
//     setPhotoPreview(null);
//     if (isMainFormRoute) {
//       mainForm.setValue('photo', undefined, { shouldValidate: true });
//     } else {
//       followUpForm.setValue('photo', undefined, { shouldValidate: true });
//     }
//     if (inputRef.current) {
//       inputRef.current.value = '';
//     }
//   };

//   const onSubmitMain = (data: ClientIncidentFormData) => {
//     const payload: ClientIncidentFormData = {
//       ...data,
//       client_email: selectedClient.email || data.client_email
//     };

//     dispatch(submitClientIncident(payload)).then(() => {
//       mainForm.reset();
//       setPhotoPreview(null);
//       if (inputRef.current) {
//         inputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearClientIncidentState()), 5000);
//     });
//   };

//   const onSubmitFollowUp = (data: ClientIncidentFormData) => {
//     const payload: ClientIncidentFormData = {
//       id: incidentId,
//       date_of_incident: initialData?.date || data.date_of_incident,
//       time_of_incident: initialData?.time || data.time_of_incident,
//       location_of_incident: initialData?.location || data.location_of_incident,
//       description: initialData?.description || data.description,
//       individuals_involved: initialData?.individuals || data.individuals_involved,
//       witnesses: initialData?.witnesses || data.witnesses,
//       actions_taken_during: initialData?.actions_during || data.actions_taken_during,
//       client_name: initialData?.client_name || data.client_name,
//       ndis_number: initialData?.ndis_number || data.ndis_number,
//       client_condition: initialData?.client_condition || data.client_condition,
//       was_injured: initialData?.injured || data.was_injured,
//       injury_description: initialData?.injury_details || data.injury_description,
//       first_aid_provided: initialData?.first_aid || data.first_aid_provided,
//       property_damage: initialData?.property_damage || data.property_damage,
//       damage_description: initialData?.damage_description || data.damage_description,
//       immediate_actions: initialData?.actions_after || data.immediate_actions,
//       escalated_to_management: data.escalated_to_management,
//       manager_name: data.manager_name,
//       reported_externally: data.reported_externally,
//       external_party: data.external_party,
//       follow_up: data.follow_up,
//       recommendations: data.recommendations,
//       support_worker_name: initialData?.sw_name || data.support_worker_name,
//       support_worker_signature: initialData?.sw_signature || data.support_worker_signature,
//       date_completed: initialData?.date_completed || data.date_completed,
//       photo: initialData?.photo||"",
//       client_email: selectedClient.email || data.client_email
//     };

//     console.log('payload', payload);

//     dispatch(submitClientIncident(payload)).then(() => {
//       followUpForm.reset();
//       setPhotoPreview(null);
//       if (inputRef.current) {
//         inputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearClientIncidentState()), 5000);
//       if (onClose) {
//         onClose();
//       }
//     });
//   };

//   const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     mainForm.reset();
//     setPhotoPreview(null);
//     if (inputRef.current) {
//       inputRef.current.value = '';
//     }
//     dispatch(clearClientIncidentState());
//   };

//   const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     followUpForm.reset();
//     setPhotoPreview(null);
//     if (inputRef.current) {
//       inputRef.current.value = '';
//     }
//     dispatch(clearClientIncidentState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isFollowUpRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isFollowUpRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.error.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.error.contrastText
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isMainFormRoute ? 'Client Incident Report' : 'Incident Follow-Up Form'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isMainFormRoute
//               ? 'For documenting client incidents'
//               : 'For follow-up actions on client incidents'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearClientIncidentState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearClientIncidentState())}
//           >
//             {error}
//           </Alert>
//         )}
//         {isFollowUpRoute && alreadyFilled && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             This follow-up form has already been filled.
//           </Alert>
//         )}
//         {clientsError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
//             {clientsError}
//           </Alert>
//         )}
//         {staffError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
//             {staffError}
//           </Alert>
//         )}

//         {isMainFormRoute && (
//           <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date_of_incident"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Incident"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_of_incident}
//                         helperText={mainForm.formState.errors.date_of_incident?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="time_of_incident"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Time of Incident"
//                         type="time"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaClock size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.time_of_incident}
//                         helperText={mainForm.formState.errors.time_of_incident?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="location_of_incident"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Exact Location of Incident"
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., Client’s Home, Community Setting, Public Area"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.location_of_incident}
//                         helperText={
//                           mainForm.formState.errors.location_of_incident?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Incident Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaExclamationTriangle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Incident Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Detailed Description of the Incident"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="Provide a factual and detailed account"
//                         {...field}
//                         error={!!mainForm.formState.errors.description}
//                         helperText={mainForm.formState.errors.description?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="individuals_involved"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Individuals Involved"
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., Client: John Doe"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.individuals_involved}
//                         helperText={
//                           mainForm.formState.errors.individuals_involved?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="witnesses"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Witnesses (Optional)"
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., Support Worker: Jane Smith"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.witnesses}
//                         helperText={mainForm.formState.errors.witnesses?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="actions_taken_during"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Actions Taken During the Incident"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="Immediate response by the support worker or others"
//                         {...field}
//                         error={!!mainForm.formState.errors.actions_taken_during}
//                         helperText={
//                           mainForm.formState.errors.actions_taken_during?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Client Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Client Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="client_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           size="small"
//                           options={clientsList}
//                           getOptionLabel={(option: Client) => option.label}
//                           value={clientsList.find((client) => client.label === field.value) || null}
//                           onChange={(_, newValue) => field.onChange(newValue?.label || '')}
//                           disabled={isClientsLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               label="Client's Full Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 )
//                               }}
//                               sx={{
//                                 '& .MuiInputBase-root': {
//                                   backgroundColor:
//                                     theme.palette.mode === 'light' ? '#fff' : '#424242'
//                                 },
//                                 '& .MuiInputLabel-root': {
//                                   color: theme.palette.text.secondary
//                                 }
//                               }}
//                               error={!!mainForm.formState.errors.client_name}
//                               helperText={mainForm.formState.errors.client_name?.message as string}
//                             />
//                           )}
//                           noOptionsText={
//                             isClientsLoading ? 'Loading clients...' : 'No clients available'
//                           }
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="ndis_number"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="NDIS Number"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.ndis_number}
//                         helperText={mainForm.formState.errors.ndis_number?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="client_condition"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Client's Condition After the Incident"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="Describe physical and emotional state"
//                         {...field}
//                         error={!!mainForm.formState.errors.client_condition}
//                         helperText={mainForm.formState.errors.client_condition?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Injuries or Damage */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaExclamationTriangle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Injuries or Damage
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was Anyone Injured?
//                     </Typography>
//                     <Controller
//                       name="was_injured"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.was_injured && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.was_injured.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {was_injured === 'Yes' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="injury_description"
//                         control={mainForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Nature and Extent of Injuries"
//                             multiline
//                             rows={isMobile ? 3 : 4}
//                             fullWidth
//                             margin="normal"
//                             {...field}
//                             error={!!mainForm.formState.errors.injury_description}
//                             helperText={
//                               mainForm.formState.errors.injury_description?.message as string
//                             }
//                           />
//                         )}
//                       />
//                       <FormControl component="fieldset" margin="normal" fullWidth>
//                         <Typography
//                           variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                           sx={{ mb: 1, pl: 1 }}
//                         >
//                           First Aid or Medical Attention Provided?
//                         </Typography>
//                         <Controller
//                           name="first_aid_provided"
//                           control={mainForm.control}
//                           render={({ field }) => (
//                             <RadioGroup
//                               {...field}
//                               onChange={(e) => field.onChange(e.target.value)}
//                               sx={{
//                                 display: 'flex',
//                                 flexDirection: isMobile ? 'column' : 'row',
//                                 gap: isMobile ? 0.5 : 1,
//                                 pl: 2
//                               }}
//                             >
//                               <FormControlLabel
//                                 value="Yes"
//                                 control={<Radio size="small" color="primary" />}
//                                 label={
//                                   <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                     Yes
//                                   </Typography>
//                                 }
//                               />
//                               <FormControlLabel
//                                 value="No"
//                                 control={<Radio size="small" color="primary" />}
//                                 label={
//                                   <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                                 }
//                               />
//                             </RadioGroup>
//                           )}
//                         />
//                         {mainForm.formState.errors.first_aid_provided && (
//                           <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                             {mainForm.formState.errors.first_aid_provided.message as string}
//                           </Typography>
//                         )}
//                       </FormControl>
//                     </Box>
//                   )}
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was There Any Property Damage?
//                     </Typography>
//                     <Controller
//                       name="property_damage"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.property_damage && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.property_damage.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {property_damage === 'Yes' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="damage_description"
//                         control={mainForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Describe Property Damage"
//                             multiline
//                             rows={isMobile ? 3 : 4}
//                             fullWidth
//                             margin="normal"
//                             {...field}
//                             error={!!mainForm.formState.errors.damage_description}
//                             helperText={
//                               mainForm.formState.errors.damage_description?.message as string
//                             }
//                           />
//                         )}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Attachments */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCamera
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Attachments
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="photo"
//                     control={mainForm.control}
//                     render={({ field: { onChange, onBlur, ...field } }) => (
//                       <Box>
//                         <TextField
//                           size="small"
//                           label="Upload Photo"
//                           type="file"
//                           fullWidth
//                           margin="normal"
//                           inputRef={inputRef}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCamera size={16} />
//                               </InputAdornment>
//                             ),
//                             inputProps: {
//                               accept: 'image/*'
//                             }
//                           }}
//                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
//                             handlePhotoChange(e, onChange)
//                           }
//                           onBlur={onBlur}
//                           error={!!mainForm.formState.errors.photo}
//                           helperText={mainForm.formState.errors.photo?.message as string}
//                         />
//                         {photoPreview && isLargeScreen && (
//                           <Box sx={{ mt: 1, textAlign: 'left' }}>
//                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                               Photo Preview
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                               <Avatar
//                                 src={photoPreview}
//                                 variant="rounded"
//                                 sx={{
//                                   width: isMobile ? '100%' : 150,
//                                   height: 150,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                               <IconButton
//                                 size="small"
//                                 onClick={handleRemovePhoto}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: -10,
//                                   right: -10,
//                                   bgcolor: theme.palette.error.main,
//                                   color: theme.palette.common.white,
//                                   '&:hover': {
//                                     bgcolor: theme.palette.error.dark
//                                   }
//                                 }}
//                               >
//                                 <FiTrash size={16} />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         )}
//                       </Box>
//                     )}
//                   />
//                 </Grid>
//                 {photoPreview && !isLargeScreen && (
//                   <Grid item xs={12}>
//                     <Box
//                       sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={photoPreview}
//                           variant="rounded"
//                           sx={{
//                             width: isMobile ? '100%' : 150,
//                             height: isMobile ? 150 : 150,
//                             mt: isMobile ? 1 : 0,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <IconButton
//                           size="small"
//                           onClick={handleRemovePhoto}
//                           sx={{
//                             position: 'absolute',
//                             top: -10,
//                             right: -10,
//                             bgcolor: theme.palette.error.main,
//                             color: theme.palette.common.white,
//                             '&:hover': {
//                               bgcolor: theme.palette.error.dark
//                             }
//                           }}
//                         >
//                           <FiTrash size={16} />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Support Worker Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Support Worker Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           size="small"
//                           options={supportWorkers}
//                           getOptionLabel={(option: StaffMember) => option.name}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => field.onChange(newValue?.name || '')}
//                           disabled={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               label="Support Worker's Full Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 )
//                               }}
//                               sx={{
//                                 '& .MuiInputBase-root': {
//                                   backgroundColor:
//                                     theme.palette.mode === 'light' ? '#fff' : '#424242'
//                                 },
//                                 '& .MuiInputLabel-root': {
//                                   color: theme.palette.text.secondary
//                                 }
//                               }}
//                               error={!!mainForm.formState.errors.support_worker_name}
//                               helperText={
//                                 mainForm.formState.errors.support_worker_name?.message as string
//                               }
//                             />
//                           )}
//                           noOptionsText={
//                             staffLoading
//                               ? 'Loading support workers...'
//                               : 'No support workers available'
//                           }
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_signature"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Signature"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaSignature size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.support_worker_signature}
//                         helperText={
//                           mainForm.formState.errors.support_worker_signature?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="date_completed"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Completed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_completed}
//                         helperText={mainForm.formState.errors.date_completed?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Immediate Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaFileAlt
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Immediate Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="immediate_actions"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Immediate Actions Taken After the Incident"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., contacting emergency services, implementing safety measures"
//                         {...field}
//                         error={!!mainForm.formState.errors.immediate_actions}
//                         helperText={mainForm.formState.errors.immediate_actions?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetMain}
//                 disabled={!mainForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Incident Report'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isFollowUpRoute && (
//           <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
//             {/* Follow-Up Actions and Reporting */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaFileAlt
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions and Reporting
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Incident Escalated to Management?
//                     </Typography>
//                     <Controller
//                       name="escalated_to_management"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.escalated_to_management && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.escalated_to_management.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {escalated_to_management === 'Yes' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="manager_name"
//                         control={followUpForm.control}
//                         render={({ field }) => (
//                           <FormControl fullWidth margin="normal">
//                             <Autocomplete
//                               size="small"
//                               options={managersList}
//                               getOptionLabel={(option: Manager) => option.name}
//                               value={
//                                 managersList.find((manager) => manager.name === field.value) || null
//                               }
//                               onChange={(_, newValue) => field.onChange(newValue?.name || '')}
//                               disabled={staffLoading}
//                               renderInput={(params) => (
//                                 <TextField
//                                   {...params}
//                                   label="Manager's Name"
//                                   InputProps={{
//                                     ...params.InputProps,
//                                     startAdornment: (
//                                       <InputAdornment position="start">
//                                         <FaUser size={16} />
//                                       </InputAdornment>
//                                     )
//                                   }}
//                                   sx={{
//                                     '& .MuiInputBase-root': {
//                                       backgroundColor:
//                                         theme.palette.mode === 'light' ? '#fff' : '#424242'
//                                     },
//                                     '& .MuiInputLabel-root': {
//                                       color: theme.palette.text.secondary
//                                     }
//                                   }}
//                                   error={!!followUpForm.formState.errors.manager_name}
//                                   helperText={
//                                     followUpForm.formState.errors.manager_name?.message as string
//                                   }
//                                 />
//                               )}
//                               noOptionsText={
//                                 staffLoading ? 'Loading managers...' : 'No managers available'
//                               }
//                             />
//                           </FormControl>
//                         )}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Incident Reported Externally?
//                     </Typography>
//                     <Controller
//                       name="reported_externally"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.reported_externally && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.reported_externally.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {reported_externally === 'Yes' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="external_party"
//                         control={followUpForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Specify External Party (e.g., Police, Ambulance, NDIS Commission)"
//                             fullWidth
//                             margin="normal"
//                             InputProps={{
//                               startAdornment: (
//                                 <InputAdornment position="start">
//                                   <FaUser size={16} />
//                                 </InputAdornment>
//                               )
//                             }}
//                             {...field}
//                             error={!!followUpForm.formState.errors.external_party}
//                             helperText={
//                               followUpForm.formState.errors.external_party?.message as string
//                             }
//                           />
//                         )}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="follow_up"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Follow-Up Actions Required"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="e.g., monitoring the client, debriefing staff"
//                         {...field}
//                         error={!!followUpForm.formState.errors.follow_up}
//                         helperText={followUpForm.formState.errors.follow_up?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="recommendations"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Recommendations for Preventing Similar Incidents"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         placeholder="Suggestions for avoiding future incidents"
//                         {...field}
//                         error={!!followUpForm.formState.errors.recommendations}
//                         helperText={
//                           followUpForm.formState.errors.recommendations?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetFollowUp}
//                 disabled={!followUpForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !incidentId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default ClientIncidentForm;

import { yupResolver } from '@hookform/resolvers/yup';
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  FaCalendarAlt,
  FaCamera,
  FaClock,
  FaExclamationTriangle,
  FaFileAlt,
  FaSignature,
  FaUndo,
  FaUser
} from 'react-icons/fa';
import { FiArrowLeft, FiTrash } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ClientIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
import {
  clearClientIncidentState,
  ClientIncidentFormData,
  submitClientIncident
} from 'slices/NdisSlices/reportAllForms/clientIncidentSlice';
import { fetchParticipantsList } from 'slices/HomeTilesSlices';
import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
import * as yup from 'yup';

// Interfaces
interface Client {
  label: string;
  id: number;
  email: string;
}

interface StaffMember {
  name: string;
  email: string;
}

interface Manager {
  name: string;
  email: string;
}

interface UserDetails {
  email: string;
  name: string;
  role: { role_id: string }[];
}

// Validation schemas
const mainSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_incident: yup.string().required('Date of incident is required'),
    time_of_incident: yup.string().required('Time of incident is required'),
    location_of_incident: yup.string().required('Location of incident is required'),
    description: yup.string().required('Description of incident is required'),
    individuals_involved: yup.string().required('Name(s) of individuals involved is required'),
    witnesses: yup.string().optional().default(''),
    actions_taken_during: yup.string().required('Actions taken during incident is required'),
    client_name: yup.string().required('Client name is required'),
    ndis_number: yup.string().required('NDIS number is required'),
    client_condition: yup.string().required('Client condition is required'),
    was_injured: yup.string().required('Please specify if anyone was injured'),
    injury_description: yup.string().when('was_injured', {
      is: 'Yes',
      then: (schema) => schema.required('Nature and extent of injuries is required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    first_aid_provided: yup.string().when('was_injured', {
      is: 'Yes',
      then: (schema) => schema.required('Please specify if first aid was provided'),
      otherwise: (schema) => schema.optional().default('')
    }),
    property_damage: yup.string().required('Please specify if there was property damage'),
    damage_description: yup.string().when('property_damage', {
      is: 'Yes',
      then: (schema) => schema.required('Property damage details are required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    immediate_actions: yup.string().required('Immediate actions taken is required'),
    escalated_to_management: yup.string().optional().default(''),
    manager_name: yup.string().optional().default(''),
    reported_externally: yup.string().optional().default(''),
    external_party: yup.string().optional().default(''),
    follow_up: yup.string().optional().default(''),
    recommendations: yup.string().optional().default(''),
    support_worker_name: yup.string().required('Support worker name is required'),
    support_worker_signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required'),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

const followUpSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_incident: yup.string().optional().default(''),
    time_of_incident: yup.string().optional().default(''),
    location_of_incident: yup.string().optional().default(''),
    description: yup.string().optional().default(''),
    individuals_involved: yup.string().optional().default(''),
    witnesses: yup.string().optional().default(''),
    actions_taken_during: yup.string().optional().default(''),
    client_name: yup.string().optional().default(''),
    ndis_number: yup.string().optional().default(''),
    client_condition: yup.string().optional().default(''),
    was_injured: yup.string().optional().default(''),
    injury_description: yup.string().optional().default(''),
    first_aid_provided: yup.string().optional().default(''),
    property_damage: yup.string().optional().default(''),
    damage_description: yup.string().optional().default(''),
    immediate_actions: yup.string().optional().default(''),
    escalated_to_management: yup.string().required('Please specify if incident was escalated'),
    manager_name: yup.string().when('escalated_to_management', {
      is: 'Yes',
      then: (schema) => schema.required('Manager name is required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    reported_externally: yup
      .string()
      .required('Please specify if incident was reported externally'),
    external_party: yup.string().when('reported_externally', {
      is: 'Yes',
      then: (schema) => schema.required('External report details are required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    follow_up: yup.string().required('Follow-up actions are required'),
    recommendations: yup.string().required('Recommendations are required'),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the incident is resolved')
      .required('Please specify if the incident is resolved'),
    support_worker_name: yup.string().optional().default(''),
    support_worker_signature: yup.string().optional().default(''),
    date_completed: yup.string().optional().default(''),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

interface Props {
  initialData?: ClientIncident;
  onClose?: () => void;
}

const ClientIncidentForm: React.FC<Props> = ({ initialData, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.clientIncident);
  const [photoPreview, setPhotoPreview] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Redux state data
  const selectedProjectId = useTypedSelector(
    (state: RootState) => state.homeTilesServices.selectedProjectId
  );
  const selectedServiceTitle = useTypedSelector(
    (state: RootState) => state.serviceSelected.selectedServiceTitle
  );
  const participantsList = useTypedSelector(
    (state: RootState) => state?.homeTilesServices?.participants
  ) || { participants_list: [] };
  const supportWorkers = useTypedSelector((state: RootState) =>
    (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
      name: worker.name,
      email: worker.email || ''
    }))
  ) as StaffMember[];
  const managersList = useTypedSelector((state: RootState) =>
    (state.calendarEvents.staffList?.['Manager'] || []).map((worker: any) => ({
      name: worker.name,
      email: worker.email || ''
    }))
  ) as Manager[];
  const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);

  // Local storage data
  const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
    label?: string;
    id?: number;
    email?: string;
    ndisNumber?: string;
  };
  const loginInfo = localStorage.getItem('user-details');
  const userDetails: UserDetails | null = loginInfo ? JSON.parse(loginInfo) : null;

  // Prepare clients list, ensuring selectedClient is included
  const clientsList = useMemo(() => {
    const list =
      participantsList.participants_list?.map(
        (participant: { name: string; email: string }, index: number) => ({
          label: participant.name || `Client ${index + 1}`,
          id: index + 1,
          email: participant.email
        })
      ) || [];
    if (
      selectedClient?.label &&
      selectedClient?.email &&
      !list.some((client) => client.label === selectedClient.label)
    ) {
      list.push({
        label: selectedClient.label,
        id: selectedClient.id || list.length + 1,
        email: selectedClient.email
      });
    }
    return list;
  }, [participantsList.participants_list, selectedClient]);

  // State for loading and errors
  const [isClientsLoading, setIsClientsLoading] = useState(false);
  const [clientsError, setClientsError] = useState<string | null>(null);
  const [staffError, setStaffError] = useState<string | null>(null);

  // Fetch participants
  useEffect(() => {
    if (
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      setIsClientsLoading(true);
      dispatch(
        fetchParticipantsList({
          group_id: selectedProjectId || '',
          service_name_id: selectedServiceTitle || '',
          nested_component_id: location.pathname,
          email: userDetails.email,
          roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
          client_name: ''
        })
      )
        .then(() => {
          setIsClientsLoading(false);
        })
        .catch((error: unknown) => {
          setIsClientsLoading(false);
          setClientsError('Failed to load clients. Please try again later.');
        });
    } else {
      setIsClientsLoading(false);
    }
  }, [selectedProjectId]);

  // Fetch staff (support workers and managers)
  useEffect(() => {
    if (
      selectedClient?.label &&
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
      const basePayload = {
        group_id: selectedProjectId,
        service_name_id: selectedServiceTitle.replace(' ', '_'),
        nested_component_id: 'Staff_List',
        email_loggedIn_userEmail: userDetails.email,
        roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
        client_name: selectedClient.label?.replace(' ', '_') || '',
        approved_user: approvedUser,
        curr_loggIn_userRoles: userDetails?.name || ''
      };

      // Fetch support workers
      dispatch(fetchStaffByRoles({ ...basePayload, roles: ['Support worker'] }))
        .then(() => {
          // Handle success if needed
        })
        .catch((error: unknown) => {
          setStaffError('Failed to load support workers. Please try again later.');
        });

      // Fetch managers
      dispatch(fetchStaffByRoles({ ...basePayload, roles: ['Manager'] }))
        .then(() => {
          // Handle success if needed
        })
        .catch((error: unknown) => {
          setStaffError('Failed to load managers. Please try again later.');
        });
    }
  }, [selectedClient?.label]);

  // Determine which form section to show
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'incidents';
  const incidentId = initialData?.id || undefined;

  const isMainFormRoute = location.pathname === '/Client-Incident';
  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

  // Check if Follow-Up form is already filled or resolved
  const [alreadyFilled, setAlreadyFilled] = useState(false);
  const [isResolved, setIsResolved] = useState(false);
  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      const isFilled = [
        initialData.follow_up,
        initialData.recommendations,
        initialData.escalated,
        initialData.manager_name,
        initialData.externally_reported,
        initialData.external_party
      ].some((field) => field !== undefined && field !== null && field !== '');
      setAlreadyFilled(isFilled);
      setIsResolved(initialData.resolved === 'Yes');
    } else {
      setAlreadyFilled(false);
      setIsResolved(false);
    }
  }, [initialData, isFollowUpRoute]);

  // Find default values for Autocomplete
  const defaultClient =
    clientsList.find(
      (client) => client.label === (initialData?.client_name || selectedClient?.label)
    ) || null;
  const defaultSupportWorker =
    supportWorkers.find((worker) => worker.name === (initialData?.sw_name || userDetails?.name)) ||
    null;
  const defaultManager =
    managersList.find((manager) => manager.name === initialData?.manager_name) || null;

  // Use separate useForm hooks for each route
  const defaultDateTime = new Date().toISOString().split('T')[0];
  const mainForm = useForm<ClientIncidentFormData>({
    resolver: yupResolver(mainSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date_of_incident: initialData?.date || defaultDateTime,
      time_of_incident: initialData?.time || '',
      location_of_incident: initialData?.location || '',
      description: initialData?.description || '',
      individuals_involved: initialData?.individuals || '',
      witnesses: initialData?.witnesses || '',
      actions_taken_during: initialData?.actions_during || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      ndis_number: initialData?.ndis_number || selectedClient?.ndisNumber || '',
      client_condition: initialData?.client_condition || '',
      was_injured: initialData?.injured || '',
      injury_description: initialData?.injury_details || '',
      first_aid_provided: initialData?.first_aid || '',
      property_damage: initialData?.property_damage || '',
      damage_description: initialData?.damage_description || '',
      immediate_actions: initialData?.actions_after || '',
      escalated_to_management: initialData?.escalated || '',
      manager_name: initialData?.manager_name || '',
      reported_externally: initialData?.externally_reported || '',
      external_party: initialData?.external_party || '',
      follow_up: initialData?.follow_up || '',
      recommendations: initialData?.recommendations || '',
      support_worker_name: initialData?.sw_name || userDetails?.name || '',
      support_worker_signature: initialData?.sw_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: selectedClient?.email || ''
    }
  });

  const followUpForm = useForm<ClientIncidentFormData>({
    resolver: yupResolver(followUpSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date_of_incident: initialData?.date || '',
      time_of_incident: initialData?.time || '',
      location_of_incident: initialData?.location || '',
      description: initialData?.description || '',
      individuals_involved: initialData?.individuals || '',
      witnesses: initialData?.witnesses || '',
      actions_taken_during: initialData?.actions_during || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      ndis_number: initialData?.ndis_number || '',
      client_condition: initialData?.client_condition || '',
      was_injured: initialData?.injured || '',
      injury_description: initialData?.injury_details || '',
      first_aid_provided: initialData?.first_aid || '',
      property_damage: initialData?.property_damage || '',
      damage_description: initialData?.damage_description || '',
      immediate_actions: initialData?.actions_after || '',
      escalated_to_management: initialData?.escalated || '',
      manager_name: initialData?.manager_name || '',
      reported_externally: initialData?.externally_reported || '',
      external_party: initialData?.external_party || '',
      follow_up: initialData?.follow_up || '',
      recommendations: initialData?.recommendations || '',
      resolved: initialData?.resolved || '', // Changed to string
      support_worker_name: initialData?.sw_name || '',
      support_worker_signature: initialData?.sw_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: selectedClient?.email || ''
    }
  });

  // Update client_email when client_name changes
  useEffect(() => {
    const selectedClientFromList = clientsList.find(
      (client) => client.label === mainForm.getValues('client_name')
    );
    if (selectedClientFromList) {
      mainForm.setValue('client_email', selectedClientFromList.email);
    }
  }, [mainForm.watch('client_name'), clientsList, mainForm]);

  useEffect(() => {
    const selectedClientFromList = clientsList.find(
      (client) => client.label === followUpForm.getValues('client_name')
    );
    if (selectedClientFromList) {
      followUpForm.setValue('client_email', selectedClientFromList.email);
    }
  }, [followUpForm.watch('client_name'), clientsList, followUpForm]);

  const was_injured = isMainFormRoute
    ? mainForm.watch('was_injured')
    : followUpForm.watch('was_injured');
  const property_damage = isMainFormRoute
    ? mainForm.watch('property_damage')
    : followUpForm.watch('property_damage');
  const escalated_to_management = isMainFormRoute
    ? mainForm.watch('escalated_to_management')
    : followUpForm.watch('escalated_to_management');
  const reported_externally = isMainFormRoute
    ? mainForm.watch('reported_externally')
    : followUpForm.watch('reported_externally');

  const handlePhotoChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: File | undefined) => void
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPhotoPreview(null);
      onChange(undefined);
    }
  };

  const handleRemovePhoto = () => {
    setPhotoPreview(null);
    if (isMainFormRoute) {
      mainForm.setValue('photo', undefined, { shouldValidate: true });
    } else {
      followUpForm.setValue('photo', undefined, { shouldValidate: true });
    }
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const onSubmitMain = (data: ClientIncidentFormData) => {
    const payload: ClientIncidentFormData = {
      ...data,
      client_email: selectedClient.email || data.client_email
    };

    dispatch(submitClientIncident(payload)).then(() => {
      mainForm.reset();
      setPhotoPreview(null);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearClientIncidentState()), 5000);
    });
  };

  const onSubmitFollowUp = (data: ClientIncidentFormData) => {
    const payload: ClientIncidentFormData = {
      id: incidentId,
      date_of_incident: initialData?.date || data.date_of_incident,
      time_of_incident: initialData?.time || data.time_of_incident,
      location_of_incident: initialData?.location || data.location_of_incident,
      description: initialData?.description || data.description,
      individuals_involved: initialData?.individuals || data.individuals_involved,
      witnesses: initialData?.witnesses || data.witnesses,
      actions_taken_during: initialData?.actions_during || data.actions_taken_during,
      client_name: initialData?.client_name || data.client_name,
      ndis_number: initialData?.ndis_number || data.ndis_number,
      client_condition: initialData?.client_condition || data.client_condition,
      was_injured: initialData?.injured || data.was_injured,
      injury_description: initialData?.injury_details || data.injury_description,
      first_aid_provided: initialData?.first_aid || data.first_aid_provided,
      property_damage: initialData?.property_damage || data.property_damage,
      damage_description: initialData?.damage_description || data.damage_description,
      immediate_actions: initialData?.actions_after || data.immediate_actions,
      escalated_to_management: data.escalated_to_management,
      manager_name: data.manager_name,
      reported_externally: data.reported_externally,
      external_party: data.external_party,
      follow_up: data.follow_up,
      recommendations: data.recommendations,
      resolved: data.resolved, // Send as string
      support_worker_name: initialData?.sw_name || data.support_worker_name,
      support_worker_signature: initialData?.sw_signature || data.support_worker_signature,
      date_completed: initialData?.date_completed || data.date_completed,
      photo: data.photo || initialData?.photo || '',
      client_email: selectedClient.email || data.client_email
    };

    dispatch(submitClientIncident(payload)).then(() => {
      followUpForm.reset();
      setPhotoPreview(null);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearClientIncidentState()), 5000);
      if (onClose) {
        onClose();
      }
    });
  };

  const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mainForm.reset();
    setPhotoPreview(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    dispatch(clearClientIncidentState());
  };

  const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    followUpForm.reset();
    setPhotoPreview(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    dispatch(clearClientIncidentState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isFollowUpRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isFollowUpRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.error.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.error.contrastText
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isMainFormRoute ? 'Client Incident Report' : 'Incident Follow-Up Form'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isMainFormRoute
              ? 'For documenting client incidents'
              : 'For follow-up actions on client incidents'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearClientIncidentState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearClientIncidentState())}
          >
            {error}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This follow-up form has already been filled.
          </Alert>
        )}
        {isFollowUpRoute && isResolved && (
          <Alert severity="info" sx={{ mb: 2 }}>
            This incident has already been resolved by{' '}
            {initialData?.manager_name || initialData?.sw_name || 'unknown'}.
          </Alert>
        )}
        {clientsError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
            {clientsError}
          </Alert>
        )}
        {staffError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
            {staffError}
          </Alert>
        )}

        {isMainFormRoute && (
          <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_of_incident"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Incident"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_of_incident}
                        helperText={mainForm.formState.errors.date_of_incident?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="time_of_incident"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Time of Incident"
                        type="time"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaClock size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.time_of_incident}
                        helperText={mainForm.formState.errors.time_of_incident?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="location_of_incident"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Exact Location of Incident"
                        fullWidth
                        margin="normal"
                        placeholder="e.g., Client’s Home, Community Setting, Public Area"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.location_of_incident}
                        helperText={
                          mainForm.formState.errors.location_of_incident?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Incident Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaExclamationTriangle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Incident Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Detailed Description of the Incident"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="Provide a factual and detailed account"
                        {...field}
                        error={!!mainForm.formState.errors.description}
                        helperText={mainForm.formState.errors.description?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="individuals_involved"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Individuals Involved"
                        fullWidth
                        margin="normal"
                        placeholder="e.g., Client: John Doe"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.individuals_involved}
                        helperText={
                          mainForm.formState.errors.individuals_involved?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="witnesses"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Witnesses (Optional)"
                        fullWidth
                        margin="normal"
                        placeholder="e.g., Support Worker: Jane Smith"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.witnesses}
                        helperText={mainForm.formState.errors.witnesses?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="actions_taken_during"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Actions Taken During the Incident"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="Immediate response by the support worker or others"
                        {...field}
                        error={!!mainForm.formState.errors.actions_taken_during}
                        helperText={
                          mainForm.formState.errors.actions_taken_during?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Client Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Client Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="client_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          size="small"
                          options={clientsList}
                          getOptionLabel={(option: Client) => option.label}
                          value={clientsList.find((client) => client.label === field.value) || null}
                          onChange={(_, newValue) => field.onChange(newValue?.label || '')}
                          disabled={isClientsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Client's Full Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                )
                              }}
                              sx={{
                                '& .MuiInputBase-root': {
                                  backgroundColor:
                                    theme.palette.mode === 'light' ? '#fff' : '#424242'
                                },
                                '& .MuiInputLabel-root': {
                                  color: theme.palette.text.secondary
                                }
                              }}
                              error={!!mainForm.formState.errors.client_name}
                              helperText={mainForm.formState.errors.client_name?.message as string}
                            />
                          )}
                          noOptionsText={
                            isClientsLoading ? 'Loading clients...' : 'No clients available'
                          }
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="ndis_number"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="NDIS Number"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.ndis_number}
                        helperText={mainForm.formState.errors.ndis_number?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="client_condition"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Client's Condition After the Incident"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="Describe physical and emotional state"
                        {...field}
                        error={!!mainForm.formState.errors.client_condition}
                        helperText={mainForm.formState.errors.client_condition?.message as string}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Injuries or Damage */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaExclamationTriangle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Injuries or Damage
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was Anyone Injured?
                    </Typography>
                    <Controller
                      name="was_injured"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2,
                            flexWrap: 'wrap'
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.was_injured && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.was_injured.message as string}
                      </Typography>
                    )}
                  </FormControl>
                  {was_injured === 'Yes' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="injury_description"
                        control={mainForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="Nature and Extent of Injuries"
                            multiline
                            rows={isMobile ? 3 : 4}
                            fullWidth
                            margin="normal"
                            {...field}
                            error={!!mainForm.formState.errors.injury_description}
                            helperText={
                              mainForm.formState.errors.injury_description?.message as string
                            }
                          />
                        )}
                      />
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <Typography
                          variant={isMobile ? 'subtitle2' : 'subtitle1'}
                          sx={{ mb: 1, pl: 1 }}
                        >
                          First Aid or Medical Attention Provided?
                        </Typography>
                        <Controller
                          name="first_aid_provided"
                          control={mainForm.control}
                          render={({ field }) => (
                            <RadioGroup
                              {...field}
                              onChange={(e) => field.onChange(e.target.value)}
                              sx={{
                                display: 'flex',
                                flexDirection: isMobile ? 'column' : 'row',
                                gap: isMobile ? 0.5 : 1,
                                pl: 2
                              }}
                            >
                              <FormControlLabel
                                value="Yes"
                                control={<Radio size="small" color="primary" />}
                                label={
                                  <Typography variant={isMobile ? 'body2' : 'body1'}>
                                    Yes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="No"
                                control={<Radio size="small" color="primary" />}
                                label={
                                  <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                                }
                              />
                            </RadioGroup>
                          )}
                        />
                        {mainForm.formState.errors.first_aid_provided && (
                          <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                            {mainForm.formState.errors.first_aid_provided.message as string}
                          </Typography>
                        )}
                      </FormControl>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was There Any Property Damage?
                    </Typography>
                    <Controller
                      name="property_damage"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2,
                            flexWrap: 'wrap'
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.property_damage && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.property_damage.message as string}
                      </Typography>
                    )}
                  </FormControl>
                  {property_damage === 'Yes' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="damage_description"
                        control={mainForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="Describe Property Damage"
                            multiline
                            rows={isMobile ? 3 : 4}
                            fullWidth
                            margin="normal"
                            {...field}
                            error={!!mainForm.formState.errors.damage_description}
                            helperText={
                              mainForm.formState.errors.damage_description?.message as string
                            }
                          />
                        )}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>

            {/* Attachments */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCamera
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Attachments
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="photo"
                    control={mainForm.control}
                    render={({ field: { onChange, onBlur, ...field } }) => (
                      <Box>
                        <TextField
                          size="small"
                          label="Upload Photo"
                          type="file"
                          fullWidth
                          margin="normal"
                          inputRef={inputRef}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCamera size={16} />
                              </InputAdornment>
                            ),
                            inputProps: {
                              accept: 'image/*'
                            }
                          }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handlePhotoChange(e, onChange)
                          }
                          onBlur={onBlur}
                          error={!!mainForm.formState.errors.photo}
                          helperText={mainForm.formState.errors.photo?.message as string}
                        />
                        {photoPreview && isLargeScreen && (
                          <Box sx={{ mt: 1, textAlign: 'left' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              Photo Preview
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <Avatar
                                src={photoPreview}
                                variant="rounded"
                                sx={{
                                  width: isMobile ? '100%' : 150,
                                  height: 150,
                                  objectFit: 'contain'
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemovePhoto}
                                sx={{
                                  position: 'absolute',
                                  top: -10,
                                  right: -10,
                                  bgcolor: theme.palette.error.main,
                                  color: theme.palette.common.white,
                                  '&:hover': {
                                    bgcolor: theme.palette.error.dark
                                  }
                                }}
                              >
                                <FiTrash size={16} />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  />
                </Grid>
                {photoPreview && !isLargeScreen && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Avatar
                          src={photoPreview}
                          variant="rounded"
                          sx={{
                            width: isMobile ? '100%' : 150,
                            height: isMobile ? 150 : 150,
                            mt: isMobile ? 1 : 0,
                            objectFit: 'contain'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemovePhoto}
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            '&:hover': {
                              bgcolor: theme.palette.error.dark
                            }
                          }}
                        >
                          <FiTrash size={16} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Support Worker Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Support Worker Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          size="small"
                          options={supportWorkers}
                          getOptionLabel={(option: StaffMember) => option.name}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                          disabled={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Support Worker's Full Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                )
                              }}
                              sx={{
                                '& .MuiInputBase-root': {
                                  backgroundColor:
                                    theme.palette.mode === 'light' ? '#fff' : '#424242'
                                },
                                '& .MuiInputLabel-root': {
                                  color: theme.palette.text.secondary
                                }
                              }}
                              error={!!mainForm.formState.errors.support_worker_name}
                              helperText={
                                mainForm.formState.errors.support_worker_name?.message as string
                              }
                            />
                          )}
                          noOptionsText={
                            staffLoading
                              ? 'Loading support workers...'
                              : 'No support workers available'
                          }
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_signature"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Signature"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaSignature size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.support_worker_signature}
                        helperText={
                          mainForm.formState.errors.support_worker_signature?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="date_completed"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Completed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_completed}
                        helperText={mainForm.formState.errors.date_completed?.message as string}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Immediate Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaFileAlt
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Immediate Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="immediate_actions"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Immediate Actions Taken After the Incident"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="e.g., contacting emergency services, implementing safety measures"
                        {...field}
                        error={!!mainForm.formState.errors.immediate_actions}
                        helperText={mainForm.formState.errors.immediate_actions?.message as string}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 2
                  }
                }}
                startIcon={<FaUndo />}
                onClick={handleResetMain}
              >
                Reset
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 2
                  }
                }}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Submit Incident Report'
                )}
              </Button>
            </Box>
          </form>
        )}

        {isFollowUpRoute && (
          <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
            {/* Follow-Up Actions */}
            <Box
              sx={{
                mb: isMobile ? 3 : 4,
                opacity: isResolved ? 0.5 : 1,
                pointerEvents: isResolved ? 'none' : 'auto'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaFileAlt
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Incident Escalated to Management?
                    </Typography>
                    <Controller
                      name="escalated_to_management"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.escalated_to_management && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.escalated_to_management.message as string}
                      </Typography>
                    )}
                  </FormControl>
                  {escalated_to_management === 'Yes' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="manager_name"
                        control={followUpForm.control}
                        render={({ field }) => (
                          <FormControl fullWidth margin="normal">
                            <Autocomplete
                              size="small"
                              options={managersList}
                              getOptionLabel={(option: Manager) => option.name}
                              value={
                                managersList.find((manager) => manager.name === field.value) || null
                              }
                              onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                              disabled={staffLoading}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Manager's Full Name"
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <FaUser size={16} />
                                      </InputAdornment>
                                    )
                                  }}
                                  sx={{
                                    '& .MuiInputBase-root': {
                                      backgroundColor:
                                        theme.palette.mode === 'light' ? '#fff' : '#424242'
                                    },
                                    '& .MuiInputLabel-root': {
                                      color: theme.palette.text.secondary
                                    }
                                  }}
                                  error={!!followUpForm.formState.errors.manager_name}
                                  helperText={
                                    followUpForm.formState.errors.manager_name?.message as string
                                  }
                                />
                              )}
                              noOptionsText={
                                staffLoading ? 'Loading managers...' : 'No managers available'
                              }
                            />
                          </FormControl>
                        )}
                      />
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Incident Reported Externally?
                    </Typography>
                    <Controller
                      name="reported_externally"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.reported_externally && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.reported_externally.message as string}
                      </Typography>
                    )}
                  </FormControl>
                  {reported_externally === 'Yes' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="external_party"
                        control={followUpForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="External Report Details"
                            multiline
                            rows={isMobile ? 3 : 4}
                            fullWidth
                            margin="normal"
                            placeholder="e.g., Police, NDIS Commission"
                            {...field}
                            error={!!followUpForm.formState.errors.external_party}
                            helperText={
                              followUpForm.formState.errors.external_party?.message as string
                            }
                          />
                        )}
                      />
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="follow_up"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Follow-Up Actions Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="Describe actions taken post-incident"
                        {...field}
                        error={!!followUpForm.formState.errors.follow_up}
                        helperText={followUpForm.formState.errors.follow_up?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="recommendations"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Recommendations to Prevent Future Incidents"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        placeholder="e.g., additional training, safety measures"
                        {...field}
                        error={!!followUpForm.formState.errors.recommendations}
                        helperText={
                          followUpForm.formState.errors.recommendations?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Incident Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.resolved.message as string}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 2
                  }
                }}
                startIcon={<FaUndo />}
                onClick={handleResetFollowUp}
                disabled={isResolved}
              >
                Reset
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 2
                  }
                }}
                disabled={loading || isResolved}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Follow-Up'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default ClientIncidentForm;